import React from 'react';
import {useComponent} from '../../component-library';
import {MeasurementStandardDetails} from './measurement-standard-details';
import {
  EfficiencyTranslations,
  MeasurementStandardEfficiencyDetails,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {DisclaimerKind} from '../../types';
import {useDisclaimer} from '../../utils/use-disclaimer';
import styled from 'styled-components';

interface EfficiencyLayerContentProps {
  disclaimerReferenceLabelTranslation: string | undefined;
  efficiencyTranslations: EfficiencyTranslations;
  measurementStandardEfficiencyDetails: MeasurementStandardEfficiencyDetails;
  modelName: string;
  closeButtonLabel: string;
  includeDisclaimerInEfficiencyLayer: boolean;
}

export const EfficiencyLayerContent = ({
  efficiencyTranslations,
  measurementStandardEfficiencyDetails,
  disclaimerReferenceLabelTranslation,
  modelName,
  closeButtonLabel,
  includeDisclaimerInEfficiencyLayer,
}: EfficiencyLayerContentProps): JSX.Element => {
  const Text = useComponent('Text');
  const Disclaimer = useComponent('Disclaimer');

  const ShowDisclaimer = (disclaimerTranslation: string): JSX.Element => {
    const disclaimer = useDisclaimer(
      disclaimerTranslation,
      DisclaimerKind.AppRendered,
      disclaimerReferenceLabelTranslation,
      closeButtonLabel
    );

    return (
      <Disclaimer
        reference={disclaimer.reference}
        text={disclaimer.text}
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- this is guaranteed to exist for module references. We decided against a complex type that would prevent the need of the assertion.
        id={disclaimer.disclaimerTextId!}
      />
    );
  };

  const {
    consumptionEmissionDisclaimers,
    consumptionEmissionDisclaimer: configConsumptionEmissionDisclaimer,
  } = efficiencyTranslations;

  const consumptionEmissionDisclaimer = configConsumptionEmissionDisclaimer
    ? configConsumptionEmissionDisclaimer
    : consumptionEmissionDisclaimers
    ? consumptionEmissionDisclaimers['WLTP']
    : undefined;

  return (
    <>
      <Text tag="h3" variant="label" bold>
        {modelName}
      </Text>

      <MeasurementStandardDetails
        details={measurementStandardEfficiencyDetails}
        disclaimerReferenceLabelTranslation={
          disclaimerReferenceLabelTranslation
        }
        efficiencyTranslations={efficiencyTranslations}
        closeButtonLabel={closeButtonLabel}
        includeDisclaimerInEfficiencyLayer={includeDisclaimerInEfficiencyLayer}
      />
      {includeDisclaimerInEfficiencyLayer && (
        <DisclaimerWrapper>
          {consumptionEmissionDisclaimer &&
            ShowDisclaimer(consumptionEmissionDisclaimer)}
        </DisclaimerWrapper>
      )}
    </>
  );
};
const DisclaimerWrapper = styled.div`
  padding-top: ${(props) => props.theme.internal.size.static450};
`;
